import React, { Suspense } from 'react';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import Loader from '@/components/common/Loader';

interface Options {
  fallback?: React.ReactNode;
  errorFallback?: React.ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
}

export default function loadable<P extends React.JSX.IntrinsicAttributes>(
  importFunc: () => Promise<{ default: React.ComponentType<P> }>,
  { fallback = <Loader />, errorFallback, onError }: Options = {}
) {
  const LazyComponent = React.lazy(importFunc);
  return (props: P) => (
    <ErrorBoundary fallback={errorFallback} onError={onError}>
      <Suspense fallback={fallback}>
        <LazyComponent {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}
